type Coordinate = { x: number; y: number };

const getPolygonArea = (polygon: Coordinate[]) =>
  Math.abs(
    polygon.reduce((area, point, index) => {
      const next = polygon[(index + 1) % polygon.length];
      return area + point.x * next.y - next.x * point.y;
    }, 0) / 2
  );

export const getProjectSpecDefaults = (gridHeight: number, legalBorders: Coordinate[][]) => ({
  numberOfFloors: Math.max(1, Math.floor(gridHeight / 3)),
  grossFloorSurface:
    legalBorders.length > 0
      ? (0.5 * legalBorders.reduce((area, polygon) => area + getPolygonArea(polygon), 0) * gridHeight) / 3
      : null,
});
